import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/useAuth';
import { FullPageSpinner } from '@/components/ui/Spinner';
import { ROUTES } from '@/config/navigation';

/**
 * Empeche l'affichage d'un ecran prive tant qu'aucune session n'est etablie.
 *
 * Ce garde est un CONFORT D'INTERFACE, pas une securite : il evite au visiteur
 * de voir un ecran vide. La protection reelle des donnees est assuree par les
 * policies RLS cote PostgreSQL, qui s'appliquent meme si quelqu'un contourne
 * ce composant.
 */
export function RequireAuth() {
  const { isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (isLoading) return <FullPageSpinner />;

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.signIn} state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
